import React from 'react';

/* eslint-disable */
import { images } from '../../constants';
import './AboutUs.css';

const AboutUs = () => {
  

  return (

  

  <div className="app__aboutus app__bg flex__center section__padding" id="about">
   

    <div className="app__aboutus-content flex__center" 
 >
      <div className="app__aboutus-content_about">
        <h1 className="headtext__cormorant">Volcano Université</h1>
        <img src={images.spoon} alt="about_spoon" className="spoon__img" />
        <p className="p__opensans">12 avenue Olivier Messiaen - 06 35 34 25 63 | 09 50 85 13 53
        </p>
        <p className="p__opensans"> 
        Vous êtes amateurs de la restauration rapide et vous souhaitez découvrir ce que votre région propose de meilleur ?
Vous êtes les bienvenus dans nos deux restaurants Volcano.
Notre premier fast food est situé au Mans nord depuis de plus de 5 ans et l’autre sera ouvert dans deux semaines dans le sud de Le Mans.
Nous vous accueillons dans une ambiance chaleureuse pour vous faire profiter d’un large choix de plats à emporter ou sur place.
Avec une expérience de 20 ans dans le domaine de la restauration, nous vous garantissons des repas de qualité.
        </p>
        <button type="button" className="custom__button">Détails</button>
      </div>

      <div className="app__aboutus-content_knife flex__center">
        <img src={images.knife} alt="about_knife" />
      </div>

      <div className="app__aboutus-content_history">
        <h1 className="headtext__cormorant">Volcano Oasis (Sud) </h1>
        <img src={images.spoon} alt="about_spoon" className="spoon__img" />
        <p className="p__opensans">307 bis avenue Felix Geneslay - 02 44 81 78 43</p>
        <p className="p__opensans"> 
        Nous vous suggérons une carte variée de plats copieux, de boissons rafraîchissantes et de desserts raffinés.
Laissez-vous tenter par des assiettes généreuses préparées avec des ingrédients frais et de saison.
Pour votre pause gourmande, nous vous proposons des sandwichs riches en saveurs.
Nous mettons aussi à votre disposition des tacos croustillants au kebab, au poulet et au cordon bleu.
Nos viandes sont cuites au charbon pour vous assurer des goûts authentiques.
Que vous ayez envie de naans aux tenders ou au poulet.
        </p>
        <button type="button" className="custom__button">Détails</button>
      </div>
    </div>
  </div>
)};

export default AboutUs;
